import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

import { getStudentDisplayName } from 'approot/students/logic/get-student-display-name';
import { Student, StudentProfile } from '../classroom.constants';
import type { DrawAnswerFragment } from '../../present/activity-answers.graphql.generated';
import type { AnswerFragment } from '../../present/activity-answers.graphql.generated';

export type StudentResponse = StudentProfile & {
  hasAnswer: boolean;
  uuid: string | null;
  updatedAt: Date | null;
};

export function getStudentDrawAnswers({
  studentsInClass,
  studentAnswers,
}: {
  studentsInClass: Student[];
  studentAnswers: AnswerFragment[];
}): StudentResponse[] {
  const groupedAnswers = groupBy(studentAnswers, 'studentId');

  const studentDrawAnswers = studentsInClass.map(student => {
    const allAnswers = groupedAnswers[student.id] || [];
    const drawAnswer = allAnswers[0];

    return {
      studentId: student.id,
      studentName: getStudentDisplayName(student),
      studentEmoji: student.emeji,
      hasAnswer: !!(drawAnswer?.answer as DrawAnswerFragment)?.hasDrawingData,
      uuid: drawAnswer?.uuid || null,
      updatedAt: drawAnswer?.updatedAt ? new Date(drawAnswer.updatedAt) : null,
    };
  });

  const sortedStudentDrawAnswers = sortBy(studentDrawAnswers, answer =>
    answer.studentName.toLowerCase()
  );

  const studentsWithAnswers = sortedStudentDrawAnswers.filter(
    student => student.hasAnswer
  );

  const studentsWithoutAnswers = sortedStudentDrawAnswers.filter(
    student => !student.hasAnswer
  );

  return [...studentsWithAnswers, ...studentsWithoutAnswers];
}
